import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';

@Component({
    selector: 'app-coming-soon',
    templateUrl: './coming-soon.component.html',
    styleUrls: ['./coming-soon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ComingSoonComponent implements OnInit {
  static readonly componentName = 'ComingSoonComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  constructor (
    @Inject(MAT_DIALOG_DATA)
    public sysText: any,
    private dialogRef: MatDialogRef<ComingSoonComponent>,
  ) { }

  ngOnInit() {}
}
